var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "color-filter" }, [_c('div', { staticClass: "color-filter-hd" }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-switch', { on: { "change": _vm.handleSwitchChange }, model: { value: _vm.isOpen, callback: function callback($$v) {
        _vm.isOpen = $$v;
      }, expression: "isOpen" } })], 1), _vm._v(" "), _c('color-picker', { attrs: { "disabled": !_vm.isOpen, "type": ['single'], "activeType": _vm.activeColorType, "currentColor": _vm.currentColor, "disabled-alpha": true }, on: { "changeColor": function changeColor(val) {
        return _vm.$emit('change-color', val);
      } } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };